import { TFunction } from 'i18next';
import {
    DepartmentVariableSettings,
    SettingsCategory,
} from '../../../services/api/departmentVariablesService';
import { toLabel } from './variableUtils';

export interface DepartmentUser {
    id: string;
    name: string;
    role: string;
}

export function categoryTitle(
    category: SettingsCategory,
    t: TFunction
): string {
    return (
        category.label ||
        t(`departmentVariables.sections.${category.key}.title`, category.key)
    );
}

export function variableLabel(
    variable: { name: string; label?: string },
    t: TFunction
): string {
    return (
        variable.label ||
        t(
            `departmentVariables.variables.${variable.name}.label`,
            toLabel(variable.name)
        )
    );
}

export function isLabelTaken(
    variables: { name: string; label?: string }[],
    label: string,
    t: TFunction,
    exceptName?: string
): boolean {
    const next = label.trim().toLowerCase();
    return variables.some(
        (variable) =>
            variable.name !== exceptName &&
            variableLabel(variable, t).toLowerCase() === next
    );
}

export function hasStartedSetup(settings: DepartmentVariableSettings): boolean {
    return (
        settings.variables.some((variable) => variable.stored) ||
        settings.categories.some((category) => category.kind === 'stored')
    );
}
